module.exports = __webpack_public_path__ + "static/media/viewindentsvg.8f452aa1.svg";